import { START_LOCATION } from "vue-router";
import { getSegmentId } from "@/helpers/segment/getSegmentId";

const QUIZ_ROUTE = /quiz|landing/i;
const PAGE_SUBTYPE = {
  Index: "parent_info",
  Booking: "schedule_tc",
  SuccessPage: "tc_booked",
  SuccessPageV2: "tc_booked",
  quiz_success_page: "thankyou",
  ChangeBooking: "manage_booking",
  ClientBookings: "manage_booking",
  ChangeDay: "manage_booking",
  ChangeBookingError: "manage_booking",
  BackupForm: "backup_form",
  quiz_backupForm_customV2: "backup_form",
  quiz_backupForm_success_customV2: "backup_form",
};

function pageOpts(route) {
  const name = String(route.name || "");
  const isQuiz = QUIZ_ROUTE.test(name);
  return {
    pageType: isQuiz ? "quiz" : "autobooking_form",
    pageSubtype: PAGE_SUBTYPE[name] || (isQuiz ? "ab" : ""),
    quizVersion: isQuiz ? (/V2$/.test(name) ? "v2" : "v1") : "",
  };
}

export function trackSiteEvent(name, params) {
  window.KodlandEvents?.track(name, params);
}

export function trackClientCreated(clientId, isNew) {
  trackSiteEvent("client_created", {
    client_id: String(clientId),
    is_new: isNew,
    segment: Number(getSegmentId()) || undefined,
  });
}

export function trackBookingCreated(bookingId, payload) {
  trackSiteEvent("booking_created", {
    booking_id: String(bookingId),
    client_id: String(payload.client),
    segment: Number(payload.segment) || undefined,
    mk_starts_at: payload.mk_starts_at,
    is_fake_slot: !!payload.is_fake_slot,
  });
}

export function startSiteEvents(router, getLocale) {
  if (!window.KodlandEvents) return;
  router.afterEach((to, from, failure) => {
    if (failure || from === START_LOCATION || to.path === from.path) return;
    window.KodlandEvents.pageView(pageOpts(to));
  });
  router.isReady().then(() => {
    window.__whenConsent("statistics", () => {
      window.KodlandEvents.start({ ...pageOpts(router.currentRoute.value), locale: getLocale });
    });
  });
}
